import React from "react";

import brand from "@utils/brand";
import { Container, Image, Button } from "@atoms";
import { HeadingWIcon } from "@molecules";

const HeroMembership = ({ heading, copy, link, images }) => {
  const { romero } = brand;

  return (
    <div className="relative z-0 w-full overflow-hidden pt-24 pb-12 lg:pb-20">
      <div className="z-10 sm:relative">
        <Container>
          <div className="z-0 flex w-full items-center sm:relative">
            <div className="relative z-10 w-full md:w-3/5">
              <HeadingWIcon
                icon="sunrise"
                heading={heading}
                copy={copy}
                colors={romero ? { heading: "text-blue" } : null}
              />
              <div className="mt-6">
                <Button
                  to={link.link}
                  rounded={romero}
                  color={romero ? "blue" : "red"}
                >
                  {link.text}
                </Button>
              </div>
            </div>
            {images[0] && (
              <div className="absolute inset-0 z-0 w-full opacity-25 sm:relative sm:opacity-100 md:w-2/5 md:pl-12">
                <div className="-mr-4 shadow-xl sm:-mr-10 md:-mr-12 lg:-mr-20 xl:-mr-24">
                  <Image placeholder={false} delay={0.25} image={images[0]} />
                </div>
              </div>
            )}
          </div>
          <div className="relative z-10 mt-6 flex w-full flex-wrap">
            {images[1] && (
              <div className="relative z-0 w-1/2 sm:w-1/4">
                <div className="-mx-3 mt-3 shadow-xl lg:-mx-6">
                  <Image placeholder={false} delay={0.5} image={images[1]} />
                </div>
              </div>
            )}
            {images[2] && (
              <div className="relative z-10 mt-auto w-1/2 sm:w-1/4">
                <div className="-mx-3 -ml-6 -mb-6 shadow-xl sm:-ml-3 lg:-mx-6">
                  <Image placeholder={false} delay={0.75} image={images[2]} />
                </div>
              </div>
            )}
            {images[3] && (
              <div className="relative z-0 mb-auto w-1/2 sm:mb-0 sm:w-1/4">
                <div className="-mx-3 ml-12 shadow-xl sm:-ml-3 sm:-mt-24 lg:-mx-6">
                  <Image placeholder={false} delay={1} image={images[3]} />
                </div>
              </div>
            )}
            {images[4] && (
              <div className="relative z-10 mb-auto w-1/2 sm:mb-0 sm:mt-auto sm:w-1/4">
                <div className="-mx-3 shadow-xl sm:-mb-6 lg:-mx-6">
                  <Image placeholder={false} delay={1.25} image={images[4]} />
                </div>
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

HeroMembership.defaultProps = {};

export default HeroMembership;
